import BasePointManager from "../../../../../src/managers/BasePointManager";
import { Coord } from "../../../../../src/types/Interface";
import { CIRCLE_RADIUS, RADIANS } from "../types/Config";
import { eventBus, EnumEventBus } from "./EventBus";


export default class PointManager extends BasePointManager {
  static instance: BasePointManager;

  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, RADIANS);

    eventBus.on(EnumEventBus.setRotateCircle, (v: number) => this.moveAllPoints(v));
    eventBus.on(EnumEventBus.setCentralAngle, (v: number) => this.moveCentralAngle(v));
    eventBus.on(EnumEventBus.setCircumPoint, (v: number) => this.moveCircumPoint(v));
  }
  moveAllPoints(v: number) {
    const points = this.getRedPoints();
    const pointInfoArr = this.getRefRadians().map((ref, refI) => ({ pTag: points[refI].tag, radian: ref + v / 100 * (Math.PI / 3) }));
    this.setRadian(pointInfoArr, true)
  }
  moveCentralAngle(v: number) {
    const refPoints = this.getRefRadians();
    const points = this.getRedPoints();
    const pointInfoArr = [points[0], points[1]].map((p, pI) => {
      const radian = refPoints[pI] + (pI == 0 ? 1 : -1) * v / 100 * (Math.PI / 8)
      return { pTag: p.tag, radian }
    })
    this.setRadian(pointInfoArr, true)
  }
  moveCircumPoint(v: number) {
    const circumPoint = this.getRedPoints()[2];
    const cirumRefRadian = this.getRefRadians()[2];
    this.setRadian([{ pTag: circumPoint.tag, radian: cirumRefRadian + v / 100 * Math.PI / 6 }], true)
  }
}